import { Link } from "react-router-dom";
import { P, SVG } from "../../../../AbstractElements";
import { popularCoinsTableBodyData } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";
import { Input, Label } from "reactstrap";

const PopularCoinsTableBody = () => {
  return (
    <tbody>
      {popularCoinsTableBodyData.map((data, i) => (
        <tr key={i}>
          <td>
            <div className="form-check">
              <Input type="checkbox" />
              <Label className="form-check-label" />
            </div>
          </td>
          <td>
            <div className="d-flex gap-2">
              <div className="flex-shrink-0">
                <SVG className="fill-primary animation" iconId={data.icon} />
              </div>
              <Link to={`${process.env.PUBLIC_URL}/ecommerce/pricing`}>
                <P>{data.name}</P>
              </Link>
            </div>
          </td>
          <td>
            <P>{data.price}</P>
          </td>
          <td className={`font-${data.perDay.includes("+") ? "primary" : "secondary" }`}>
            <span>{data.perDay}</span>
          </td>
          <td>
            <span>{data.perWeek}</span>
          </td>
          <td>{data.marketCap}</td>
          <td>
            <P className="m-0">{data.volume}</P>
            <span>{data.amount}</span>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default PopularCoinsTableBody;
